// ─────────────────────────────────────────────
//  UnreadBadge — numbered unread-count pill (Phase 5 messaging, D-11 / UI-SPEC).
//
//  Accent-navy fill, white 12px/700 text, fully-rounded. Used on the topbar
//  entry (total unread) and per-channel rows. Unread is NEVER signalled by
//  color alone (WCAG 1.4.1): this badge carries a NUMBER and an aria-label
//  ("N unread"), and the channel row additionally bolds its name.
//
//  • Renders nothing when count is 0 (no empty circle).
//  • Caps the visible glyph at "99+" while the aria-label keeps the true count.
//  • min 18×18px, radius.full.
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../theme/tokens";

const { color, radius, font } = tokens;

export default function UnreadBadge({ count }) {
  const n = Number(count) || 0;
  if (n <= 0) return null;

  const label = n > 99 ? "99+" : String(n);

  return (
    <span
      style={styles.badge}
      aria-label={`${n} unread`}
      // The visible glyph ("99+") is decorative vs. the true count in the
      // aria-label, so hide the text node from the a11y tree to avoid a
      // double announcement ("99 plus 130 unread").
    >
      <span aria-hidden="true">{label}</span>
    </span>
  );
}

const styles = {
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    boxSizing: "border-box",
    background: color.accent.primary, // navy #1e40af (accent, reserved)
    color: "#fff",
    fontSize: font.size.label, // 12
    fontWeight: font.weight.bold, // 700
    lineHeight: 1,
    borderRadius: radius.full,
    flexShrink: 0,
  },
};
